import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import { NuqsAdapter } from "nuqs/adapters/react";
import { QueryClientProvider } from "@tanstack/react-query";

import { AppBase } from "./app-base.tsx";
import { queryClient } from "./app/state/query-client.ts";
import { Provider as ChakraThemeProvider } from "./components/ui/provider.tsx";
import { UserFaultException } from "./shared/exceptions/user-fault-exception.ts";

Sentry.init({
  sendDefaultPii: true,
  enabled: !import.meta.env.DEV,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [Sentry.replayIntegration()],
  environment: import.meta.env.VITE_SENTRY_ENV,
  replaysSessionSampleRate:
    import.meta.env.VITE_SENTRY_ENV === "production" ? 1 : 0,
  replaysOnErrorSampleRate:
    import.meta.env.VITE_SENTRY_ENV === "production" ? 1 : 0,

  beforeSend(event, hint) {
    const exception = hint.originalException;

    return exception instanceof UserFaultException ? null : event;
  },
});

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <StrictMode>
    <NuqsAdapter>
      <QueryClientProvider client={queryClient}>
        <ChakraThemeProvider>
          <AppBase />
        </ChakraThemeProvider>
      </QueryClientProvider>
    </NuqsAdapter>
  </StrictMode>,
);
